import { render, staticRenderFns } from "./ChangeUserGroups.vue?vue&type=template&id=6cd228e9&scoped=true"
import script from "./ChangeUserGroups.vue?vue&type=script&lang=js"
export * from "./ChangeUserGroups.vue?vue&type=script&lang=js"
import style0 from "./ChangeUserGroups.vue?vue&type=style&index=0&id=6cd228e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd228e9",
  null
  
)

export default component.exports